import Link from 'next/link';

import { useBasketStore } from 'stores/use-basket-store';

import { PUBLIC_BASE_URL_ENV } from 'tools/environments';

import { Icon } from 'core/generic/elements/icons';

import styles from './basket-icon.module.scss';

export const BasketIcon = () => {
	const basketSize = useBasketStore((state) => state.basketSize);

	return (
		<Link
			href={`${PUBLIC_BASE_URL_ENV}/store/basket`}
			className={styles.basket}
			aria-label="Go to Basket"
			data-testid="basket-icon-link"
		>
			{basketSize > 0 ? (
				<span className={`${styles['number-items']} body-xxsmall bold`}>
					{basketSize}
				</span>
			) : null}
			<Icon
				variant={basketSize > 0 ? 'ShoppingBagFilled' : 'ShoppingBag'}
				className={styles['basket-icon']}
			/>
		</Link>
	);
};
